import { TransactionType } from '../../../../graphql'

export type OptionConfigOption = {
  key: string,
  label: string,
  route: string,
  transactionType: TransactionType,
  storeIdsKey: 'toIds' | 'fromIds',
}

export const optionConfig: OptionConfigOption[] = [
	// NB: no ProviderToStore/manual-adjustments entry — the popover queries by
	// fromIds (store ids) while that type's store is the toId (fromId is a
	// provider), so its row is unreachable through normal store selection.
	{
		key: 'parts-on-work-orders',
		label: 'Items on work orders',
		route: '/reports/parts-on-work-orders',
		transactionType: TransactionType.StoreToWorkOrder,
		storeIdsKey: 'fromIds',
	},

	{
		key: 'incoming-parts-transfer',
		label: 'Incoming transfers',
		route: '/reports/incoming-parts-transfers',
		transactionType: TransactionType.StoreToStore,
		storeIdsKey: 'toIds',
	},

	{
		key: 'outgoing-parts-transfer',
		label: 'Outgoing transfers',
		route: '/reports/outgoing-parts-transfers',
		transactionType: TransactionType.StoreToStore,
		storeIdsKey: 'fromIds',
	},

	{
		key: 'retail-sales',
		label: 'Retail Sales',
		route: '/reports/inventory-adjustments',
		transactionType: TransactionType.StoreToRetailSale,
		storeIdsKey: 'fromIds',
	},

	{
		key: 'part-losses',
		label: 'Item losses',
		route: '/reports/inventory-adjustments',
		transactionType: TransactionType.StoreToLoss,
		storeIdsKey: 'fromIds',
	},

	{
		key: 'obsolete-parts',
		label: 'Obsolete items',
		route: '/reports/inventory-adjustments',
		transactionType: TransactionType.StoreToObsolete,
		storeIdsKey: 'fromIds',
	},
]
